import { FULL_TRANSPARENT } from './const';
import { PreviewStateStatus, ImagePreviewState } from './types';
import type { ArdoqError } from '@ardoq/common-helpers';
import { ImageContentType, PreviewContent } from '@ardoq/api-types';
import { sanitize } from '@ardoq/html';
import { ARDOQ_DEFAULT_LOCALE, Locale } from '@ardoq/locale';
import { getZoomInOptions } from './utils';

export const getInitialState = (locale?: Locale): ImagePreviewState => ({
  locale: locale ?? ARDOQ_DEFAULT_LOCALE,
  status: PreviewStateStatus.IDLE,
  backgroundColor: FULL_TRANSPARENT,
  zoomInOptions: [],
});

export const setLoadingState = (
  state: ImagePreviewState
): ImagePreviewState => ({
  ...state,
  status: PreviewStateStatus.Loading,
});

export const setBackgroundColor = (
  state: ImagePreviewState,
  backgroundColor: string
): ImagePreviewState => ({ ...state, backgroundColor });

export const setFetchImageSuccess = (
  state: ImagePreviewState,
  { content, contentType }: PreviewContent
): ImagePreviewState => {
  const sanitizedContent =
    contentType === ImageContentType.SVG ? sanitize(content, 'svg') : content;
  const zoomInOptions = getZoomInOptions(content, contentType, state.locale);

  return {
    ...state,
    status: PreviewStateStatus.Loaded,
    content: {
      content: sanitizedContent,
      contentType,
    },
    zoomInOptions,
  };
};

export const DEFAULT_ERROR_TITLE = 'Failed to preview image';

export const setFetchImageError = (
  state: ImagePreviewState,
  error: ArdoqError,
  errorTitle: string = DEFAULT_ERROR_TITLE
): ImagePreviewState => ({
  ...state,
  errorContent: {
    title: errorTitle,
    error,
  },
  status: PreviewStateStatus.Error,
});
